export const scrollTop = () => {
  const body = document.getElementsByTagName("body")[0];
  const html = document.getElementsByTagName("html")[0];
  const elem = document.getElementsByClassName("root__container")[0];
  elem.scrollTo(0, 0);
  body.scrollTo(0, 0);
  html.scrollTo(0, 0);
};
